import { Component, OnInit } from '@angular/core';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { AccountCreationStatus } from '../detail-account-creation/detail-account-creation.component';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { callbackAdjustCA } from 'src/app/shared/constants/adjust-callback';
import {
  CheckboxModel,
  OptionRadioModel,
} from 'src/app/shared/models/common.model';
import {
  CardTypeModel,
  DetailAccountModel,
} from 'src/app/shared/models/abre-cuentas.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { ExternalResponse } from 'src/app/shared/models/channel-communicator/external-response.model';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { AgreementsModel } from 'src/app/shared/models/agreements.model';
import * as channelConstant from '../../../shared/constants/channel.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';

@Component({
  selector: 'app-principality-credit-card',
  templateUrl: './principality-credit-card.component.html',
  styleUrls: ['./principality-credit-card.component.scss'],
})
export class PrincipalityCreditCardComponent implements OnInit {
  showModal = false;
  isBtnDisabled = false;
  checkboxTerms: CheckboxModel;
  benefitsList: string[];
  transactionkit: any = [];
  detailAccountInfo: DetailAccountModel;
  transaction: any = [];
  acctStatus: AccountCreationStatus;
  acctProcessId: string;
  documentInfo: DocumentModel;
  infoInferredIncomes: any;
  showSecondaryButton = true;
  scanResponse: ExternalResponse;
  productsDetail: IProductsModel;
  selectedProduct: IProductsModel;
  selectedPayDayProduct: OptionRadioModel;
  agreementSelected: AgreementsModel;
  terms = { text: '', title: '', terms_id: '' };
  termsAndConditions: any;
  buttonLabelsModal = {};
  copiesProperty = {};
  showBackBtn = true;
  showFotter = false;
  grayZone = false;
  client: boolean;
  amountPco: string;
  cardType: CardTypeModel;
  postLogin: boolean;
  taggingService: any;
  product_type: string;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private bioCatchService: BioCatchService,
    private navigationService: NavigationService,
    public abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private bitacoraService: BitacoraService,
    private adjustEvent: AdjustEvent,
    public loader: LoaderService,
    private taggingServices: TaggingService,
    private daliService: DaliService,
    private firmlyApprovedService: FirmlyApprovedService,
  ) {
    this.headerService.show(true, false, true);
  }

  ngOnInit() {
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendPrincipalityPageLoad();
    }
    this.buttonLabelsModal = {
      primary: this.copyService.copies.principality_credit_card_modal_button,
    };
    this.checkboxTerms = {
      id: '1',
      label: this.copyService.copies.principality_credit_card_terms,
      checked: true,
      value: '1',
    };
    console.log(this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS), 'seteo');
    const postLogin = this.abreCuentasService.getPostlogin();
    const product = this.abreCuentasService.getproductSelected()
      .product_code as ProductsBiocatchEnum;
    const isEvidente = this.bioCatchService.isEvidenteCase();
    this.bioCatchService.changeContext(
      StepBiocatchEnum.vinculacion,
      product,
      !postLogin,
      isEvidente,
    );
    this.termsAndConditions =
      this.abreCuentasService.getPayDayProductSelected();
    this.acctStatus = AccountCreationStatus.NOT_REQUESTED;
    const product_type =
      this.abreCuentasService.getproductSelected().product_type;
    console.log('product_type', product_type);
    this.transaction = this.parametersService.getSetting(
      OpEnum.SAVING_TRANSACTION_KIT,
    );
    if (!this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)) {
      return;
    }
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.selectedProduct = this.abreCuentasService.getproductSelected();

    if (
      this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
    ) {
      const event = {
        eventToken: '3duuk6',
        callbackParams: callbackAdjustCA,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    setTimeout(() => {
      this.showFotter = true;
    }, 100);
    this.accountDetail();
    const creditCardTermsText = this.parametersService
      .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
      .filter(accountTerm => accountTerm.id === 2);
    this.terms = {
      text: creditCardTermsText[0].description,
      title: creditCardTermsText[0].code,
      terms_id: creditCardTermsText[0].id,
    };
    this.checkboxTerms = {
      id: this.terms.terms_id,
      label: this.copyService.copies.principality_credit_card_terms,
      checked: true,
      value: this.terms.terms_id,
    };
  }
  accountDetail() {
    this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
    let costumerData = this.abreCuentasService.getCustomerData();
    this.client = this.abreCuentasService.getProspectResponse().client;
    if (
      this.infoInferredIncomes.account_type === '211' ||
      this.infoInferredIncomes.account_type === '218' ||
      this.infoInferredIncomes.account_type === '232'
    ) {
      this.copiesProperty = {
        termsLabel: 'principality_credit_card_link_label',
        mainLabel: 'principality_credit_card_title_saving_basic',
      };
    }
    // tslint:disable-next-line:no-collapsible-if
    if (this.channelCommunicatorService.getChannelId() !== '159') {
      if (
        this.client &&
        ((costumerData ? costumerData.basic.sub_segment_id : '') === '335' ||
        (costumerData ? costumerData.basic.sub_segment_id : '') === '315')
      ) {
        this.infoInferredIncomes.segment_id =
          this.abreCuentasService.getCustomerData().basic.sub_segment_id;
      }
    }
    this.transactionkit = this.transaction.filter(
      transaction =>
        transaction.account_type === this.infoInferredIncomes.account_type &&
        transaction.segmentation_id === this.infoInferredIncomes.segment_id,
    );
    this.transactionkit = this.transactionkit[0];
  }
  /**
   * Summary Show Modal
   */
  toggleModal() {
    if (this.showSecondaryButton) {
      this.showModal = !this.showModal;
    }
    this.showSecondaryButton = true;
  }

  /**
   * Acción del modal
   *
   * *Modal action*
   *
   * @param event
   * @type {function}
   */
  modalAction(event) {
    if (event.type === 'primary') {
      this.downloadPdf();
    }
  }

  /**
   * Method to download pdf
   */
  downloadPdf() {
    // tslint:disable-next-line:no-unused-expression
    this.channelCommunicatorService.getChannelId() === '163'
      ? window.open(
        this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0]
          .pdfUrl,
      )
      : this.channelCommunicatorService
        .getImpl()
        .openPdf(
          this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0]
            .pdfUrl,
        );
  }

  /**
   * Summary Event to change checkbox and set Prop
   * @param event
   */
  checkboxChange(event: any): void {
    this.checkboxTerms.checked = event.checked;
    this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
    this.enableNextButton();
  }
  /**
   * Summary Enable the Button
   */
  enableNextButton() {
    this.isBtnDisabled =
      !this.checkboxTerms.checked;
    console.log(this.checkboxTerms.checked);
  }
  /**
   * summary shipment request open account
   */
  onNext() {
    this.bitacoraService.saveDataInBitacora('AHO_acepted');
    this.navigationService.navigateToGeneralInformation('139');
    return;
  }
  async onPrevious() {
    await this.bitacoraService.saveDataInBitacora(
      'Salida_voluntaria_oferta_AHO',
    );
    this.navigationService.goToLoginPage();
  }
  /**
   * Opens link to itau page
   *
   *
   * @memberof PrincipalityCreditCardComponent
   */
  openLink() {
    if (
      this.channelCommunicatorService.getChannelId() ===
      channelConstant.CHANNEL.PORTALALLIES.CODE
    ) {
      window.open(this.copyService.copies.principality_credit_card_link);
    } else {
      this.channelCommunicatorService
        .getImpl()
        .openExternalBrowser(
          this.copyService.copies.principality_credit_card_link,
          5,
          true,
        );
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendPrincipalityPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv14pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv14pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv14pageFamily.path,
        value: PAGEVIEW_FA.pv14pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv14subFamily.path,
        value: PAGEVIEW_FA.pv14subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv14pageAction.path,
        value: PAGEVIEW_FA.pv14pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv14pageid.path,
        value: 'PrincipalityCreditCardComponent',
      },
      {
        path: PAGEVIEW_FA.pv14transactionName.path,
        value: `${PAGEVIEW_FA.pv14transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv14transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv14transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }
}
